import '../scss/enquiry-private-person.scss';
import { Enquiry } from './modules/enquiry';

const enquiryPrivatePerson = document.querySelector('[id^="enquiryPrivatePerson"]');

// Dynamic Fields for Private Enquiry Form
const roofMaterialIdentifier = document.querySelector('[id*="roofMaterialIdentifier"]');
const roofMaterialDetails = document.querySelector('[id*="roofMaterialDetails"]');
const thermalHeatingPumpPower = document.querySelector('[id*="thermalHeatingPumpPower"]');
const thermalHeatingPumpPlanned = document.querySelector('[id*="thermalHeatingPumpPlanned"]');
const constructionPlans = document.querySelector('[id*="constructionPlans"]');
const photoOfRoof = document.querySelector('[id*="photoOfRoof"]');
const photoOfHouse = document.querySelector('[id*="photoOfHouse"]');
const photoOfMeterBox = document.querySelector('[id*="photoOfMeterBox"]');
const photoOfPlaceForTech = document.querySelector('[id*="photoOfPlaceForTech"]');
const numberOfChargingStations = document.querySelector('[id*="numberOfChargingStations"]');
const installationStreet = document.querySelector('[id*="installationStreet"]');
const installationHouseNumber = document.querySelector('[id*="installationHouseNumber"]');
const installationPostcode = document.querySelector('[id*="installationPostcode"]');
const installationCity = document.querySelector('[id*="installationCity"]');
const personalRecommendation = document.querySelector('[id*="personalRecommendation"]');

// Field triggers for Private Enquiry form
const roofTypeBrick = document.querySelector('[id*="roofMaterial-0"]');
const roofTypeFlatTile = document.querySelector('[id*="roofMaterial-1"]');
const roofTypeOther = document.querySelector('[id*="roofMaterial-5"]');
const thermalHeatingPumpExisting = document.querySelector('[id*="thermalHeatingPump-0"]');
const thermalHeatingPumpNonExisting = document.querySelector('[id*="thermalHeatingPump-1"]');
const constructionNew = document.querySelector('[id*="constructionPlanned-0"]');
const constructionExisting = document.querySelector('[id*="constructionPlanned-1"]');
const chargingStationWanted = document.querySelector('[id*="chargingStationWanted-0"]');
const differentInstallationAddress = document.querySelector('[id*="differentInstallationAddress"]');
const foundUsOn = document.querySelector('[id*="foundUsOn"]');

if (enquiryPrivatePerson) {
  new Enquiry().hideFieldsOnLoad([
    roofMaterialIdentifier,
    roofMaterialDetails,
    thermalHeatingPumpPower,
    thermalHeatingPumpPlanned,
    constructionPlans,
    photoOfRoof,
    photoOfHouse,
    photoOfMeterBox,
    photoOfPlaceForTech,
    numberOfChargingStations,
    installationStreet,
    installationHouseNumber,
    installationPostcode,
    installationCity,
    personalRecommendation
  ]);

  new Enquiry().addSubmitEventHandler(enquiryPrivatePerson);

  if (roofTypeBrick || roofTypeFlatTile || roofTypeOther) {
    new Enquiry().toggleField(
      [roofTypeBrick, roofTypeFlatTile, roofTypeOther],
      () => {
        const isOther = roofTypeOther.checked;
        const isRegular = roofTypeBrick.checked || roofTypeFlatTile.checked;

        new Enquiry().handleFieldDisplay(isOther, [roofMaterialDetails], [roofMaterialIdentifier]);
        new Enquiry().handleFieldDisplay(isRegular, [roofMaterialIdentifier], [roofMaterialDetails]);
      }
    );
  }

  if (thermalHeatingPumpExisting || thermalHeatingPumpNonExisting) {
    new Enquiry().toggleField(
      [thermalHeatingPumpExisting, thermalHeatingPumpNonExisting],
      () => {
        new Enquiry().handleFieldDisplay(thermalHeatingPumpExisting.checked, [thermalHeatingPumpPower], [thermalHeatingPumpPlanned]);
        new Enquiry().handleFieldDisplay(thermalHeatingPumpNonExisting.checked, [thermalHeatingPumpPlanned], [thermalHeatingPumpPower]);
      }
    );
  }

  if (constructionNew || constructionExisting) {
    new Enquiry().toggleField(
      [constructionNew, constructionExisting],
      () => {
        const isConstructionNew = constructionNew.checked;
        const isConstructionExisting = constructionExisting.checked;

        new Enquiry().handleFieldDisplay(isConstructionNew, [constructionPlans], [photoOfHouse, photoOfRoof, photoOfMeterBox, photoOfPlaceForTech]);
        new Enquiry().handleFieldDisplay(isConstructionExisting, [photoOfHouse, photoOfRoof, photoOfMeterBox, photoOfPlaceForTech], [constructionPlans]);
      }
    );
  }

  if (chargingStationWanted) {
    new Enquiry().toggleField(
      [chargingStationWanted],
      () => {
        new Enquiry().handleFieldDisplay(chargingStationWanted.checked, [numberOfChargingStations]);
      }
    );
  }

  if (differentInstallationAddress) {
    new Enquiry().toggleField(
      [differentInstallationAddress],
      () => {
        new Enquiry().handleFieldDisplay(differentInstallationAddress.checked, [
          installationStreet,
          installationHouseNumber,
          installationPostcode,
          installationCity
        ]);
      }
    );
  }

  if (foundUsOn) {
    new Enquiry().toggleField(
      [foundUsOn],
      () => {
        new Enquiry().handleFieldDisplay(foundUsOn.value === 'personalRecommendation', [
          personalRecommendation
        ]);
    });
  }
}
